import { mergeStrings } from "Util/mergeStrings";
import { nullIfEmpty } from "Util/nullIfEmpty";
import { searchStringFrom } from "Util/searchStringFrom";

import { Nullable } from "./Nullable";

export type Address = {
    street: Nullable<string>
    houseNumber: Nullable<string>
    entrance: Nullable<string>
    postalCode: Nullable<string>
    postalArea: Nullable<string>
    addressString: Nullable<string>
    searchStrings: {
        street: Nullable<string>
        houseNumber: Nullable<string>
        entrance: Nullable<string>
        postalCode: Nullable<string>
        postalArea: Nullable<string>
        addressString: Nullable<string>
    }
}

function addressStringFrom(
    street: Nullable<string>,
    houseNumber: Nullable<string>,
    entrance: Nullable<string>,
    postalCode: Nullable<string>,
    postalArea: Nullable<string>,
) {
    return mergeStrings(', ', [
        mergeStrings(' ', [
            street,
            houseNumber,
            entrance,
        ]),
        mergeStrings(' ', [
            postalCode,
            postalArea,
        ]),
    ])
}

export function addressFrom(
    street: Nullable<string>,
    houseNumber: Nullable<string>,
    entrance: Nullable<string>,
    postalCode: Nullable<string>,
    postalArea: Nullable<string>,
): Nullable<Address> {
    const addressString = addressStringFrom(
        street,
        houseNumber,
        entrance,
        postalCode,
        postalArea,
    )

    return nullIfEmpty({
        street,
        houseNumber,
        entrance,
        postalCode,
        postalArea,
        addressString,
        searchStrings: {
            street: searchStringFrom(street),
            houseNumber: searchStringFrom(houseNumber),
            entrance: searchStringFrom(entrance),
            postalCode: searchStringFrom(postalCode),
            postalArea: searchStringFrom(postalArea),
            addressString: searchStringFrom(addressString),
        },
    })
}
